import {Row, Col} from 'antd';
import {lbsToGrams} from "../../util/unitutils";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const DisplayBulkCostWidget = ({item, props}) => {
    const unitCost = item.bulkCost;
    const displayQuantity = fixedToDisplayUnit(item.quantity, item.unit);
    const totalCost = displayQuantity * unitCost;
    const lbsCost = lbsToGrams(parseFloat(unitCost)).toFixed(2);

    const rowStyle={margin: "5px"}
    return <div>
        <Row style={rowStyle}><Col>{`$ ${totalCost.toFixed(2)}`}</Col></Row>
        <Row style={rowStyle}><Col>{`$ ${unitCost} / g`}</Col></Row>
        <Row style={rowStyle}><Col>{`$ ${lbsCost} / lb`}</Col></Row>
    </div>
}